// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Layout for About Us Page */
.about-us-page {
    display: grid;
    gap: 20px;
    padding-left: 10%;
    padding-right: 10%;
    padding-top: 20px;
  }
  
  /* Container for main content with shadow and rounded corners */
  .content-container {
    height: 70vh;
    width: 100%;
    max-width: 1200px;  /* Limit width on large screens */
    border-radius: 10px;
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    padding: 20px;
  }
  
  /* Container for the quadrant buttons at the top */
  .buttons-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 15px;
  }
  
  /* Button style for the quadrant buttons */
  .quadrant-button {
    flex: 1 1;  /* Make buttons equally spaced */
    background-color: #007bff;
    color: white;
    height: 40px;
    border: none;
    cursor: pointer;
    border-radius: 5px;
    font-size: 16px;
    transition: background-color 0.3s ease;
    margin-right: 10px;
  }
  
  .quadrant-button:last-child {
    margin-right: 0;
  }
  
  .quadrant-button.active {
    background-color: darkblue;
  }
  
  /* Content area for the section under quadrant buttons */
  .content-area {
    flex-grow: 1;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    overflow-y: auto;  /* To handle overflow content */
  }
  
  /* Footer for buttons at the bottom of the page */
  .footer-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    padding: 10px;
    width: 100%;
  }
  
  /* Button styles for Reset and Save */
  .reset-button,
  .save-button {
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
    width: 120px;  /* Fixed width for consistency */
  }
  
  .reset-button {
    background-color: #e0e0e0;
    color: black;
    border: 1px solid lightgray;
  }
  
  .save-button {
    background-color: #007bff;
    color: white;
    border: none;
  }
  
  .reset-button:hover {
    background-color: #d3d3d3;
  }
  
  .save-button:hover {
    background-color: #0056b3;
  }
  
  /* Content container for each quadrant */
  .quadrant-content {
    padding: 20px;
  }
  
  /* Write About Us section styling */
  .write-about-us {
    margin-bottom: 20px;
  }
  
  /* Image container styling */
  .image-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  
  .about-us-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  }
  
  /* Grid layout for textareas within the content */
  .grid-container {
    display: grid;
    /* Two columns */
    gap: 20px;
  }
  
  /* Styling for textarea elements */
  textarea {
    width: 100%;
    height: 150px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
    font-size: 14px;
    resize: vertical; /* Allow resizing vertically */
    background-color: #f4f4f4;
  }
  
  textarea:focus {
    outline: none;
    border-color: #007bff;
    background-color: #ffffff;
  }
  
  /* Responsive design for smaller screens */
  @media (max-width: 768px) {
    .about-us-page {
      padding-left: 5%;
      padding-right: 5%;
    }
  
    .buttons-container {
      flex-direction: column;
    }
  
    .quadrant-button {
      width: 100%;
      margin-bottom: 10px;
    }
  
    .grid-container {
      grid-template-columns: 1fr; /* Single column for smaller screens */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/settingsComponents/aboutUsPage.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,+DAA+D;EAC/D;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB,GAAG,iCAAiC;IACrD,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,0CAA0C;IAC1C,aAAa;EACf;;EAEA,kDAAkD;EAClD;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,0CAA0C;EAC1C;IACE,SAAO,GAAG,gCAAgC;IAC1C,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,wDAAwD;EACxD;IACE,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,4CAA4C;IAC5C,gBAAgB,GAAG,+BAA+B;EACpD;;EAEA,iDAAiD;EACjD;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,aAAa;IACb,WAAW;EACb;;EAEA,qCAAqC;EACrC;;IAEE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,YAAY,GAAG,gCAAgC;EACjD;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,wCAAwC;EACxC;IACE,aAAa;EACf;;EAEA,mCAAmC;EACnC;IACE,mBAAmB;EACrB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA,iDAAiD;EACjD;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;EACX;;EAEA,kCAAkC;EAClC;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB,EAAE,8BAA8B;IAChD,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA,0CAA0C;EAC1C;IACE;MACE,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;;IAEA;MACE,0BAA0B,EAAE,sCAAsC;IACpE;EACF","sourcesContent":["/* General Layout for About Us Page */\n.about-us-page {\n    display: grid;\n    gap: 20px;\n    padding-left: 10%;\n    padding-right: 10%;\n    padding-top: 20px;\n  }\n  \n  /* Container for main content with shadow and rounded corners */\n  .content-container {\n    height: 70vh;\n    width: 100%;\n    max-width: 1200px;  /* Limit width on large screens */\n    border-radius: 10px;\n    background-color: #f8f9fa;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n  }\n  \n  /* Container for the quadrant buttons at the top */\n  .buttons-container {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    margin-bottom: 15px;\n  }\n  \n  /* Button style for the quadrant buttons */\n  .quadrant-button {\n    flex: 1;  /* Make buttons equally spaced */\n    background-color: #007bff;\n    color: white;\n    height: 40px;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n    margin-right: 10px;\n  }\n  \n  .quadrant-button:last-child {\n    margin-right: 0;\n  }\n  \n  .quadrant-button.active {\n    background-color: darkblue;\n  }\n  \n  /* Content area for the section under quadrant buttons */\n  .content-area {\n    flex-grow: 1;\n    padding: 20px;\n    background-color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);\n    overflow-y: auto;  /* To handle overflow content */\n  }\n  \n  /* Footer for buttons at the bottom of the page */\n  .footer-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px;\n    padding: 10px;\n    width: 100%;\n  }\n  \n  /* Button styles for Reset and Save */\n  .reset-button,\n  .save-button {\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n    width: 120px;  /* Fixed width for consistency */\n  }\n  \n  .reset-button {\n    background-color: #e0e0e0;\n    color: black;\n    border: 1px solid lightgray;\n  }\n  \n  .save-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n  }\n  \n  .reset-button:hover {\n    background-color: #d3d3d3;\n  }\n  \n  .save-button:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Content container for each quadrant */\n  .quadrant-content {\n    padding: 20px;\n  }\n  \n  /* Write About Us section styling */\n  .write-about-us {\n    margin-bottom: 20px;\n  }\n  \n  /* Image container styling */\n  .image-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n  }\n  \n  .about-us-image {\n    max-width: 100%;\n    height: auto;\n    border-radius: 8px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  }\n  \n  /* Grid layout for textareas within the content */\n  .grid-container {\n    display: grid;\n    /* Two columns */\n    gap: 20px;\n  }\n  \n  /* Styling for textarea elements */\n  textarea {\n    width: 100%;\n    height: 150px;\n    padding: 10px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    font-size: 14px;\n    resize: vertical; /* Allow resizing vertically */\n    background-color: #f4f4f4;\n  }\n  \n  textarea:focus {\n    outline: none;\n    border-color: #007bff;\n    background-color: #ffffff;\n  }\n  \n  /* Responsive design for smaller screens */\n  @media (max-width: 768px) {\n    .about-us-page {\n      padding-left: 5%;\n      padding-right: 5%;\n    }\n  \n    .buttons-container {\n      flex-direction: column;\n    }\n  \n    .quadrant-button {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n  \n    .grid-container {\n      grid-template-columns: 1fr; /* Single column for smaller screens */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
